/* Bandenmeesters 2.1 — authoritative header behaviour, 2026-09-10 */
(()=>{
  if(window.__bmHeaderRuntime)return;
  window.__bmHeaderRuntime=true;

  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');

  let config={};
  let trustTimer=0;
  let currentWheelKey='';
  let pendingWheelKey='';
  let currentLayer='a';
  let wheelSequence=0;
  let resizeObserver=null;

  const readConfig=()=>{
    const node=document.getElementById('bm-header-config');
    if(!node)return {};
    try{return JSON.parse(node.textContent||'{}')}catch(_){return {}}
  };
  const normaliseBrand=(value='')=>String(value).trim().toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'-');
  const cancelAnimations=(element)=>{
    try{element?.getAnimations?.().forEach(animation=>animation.cancel())}catch(_){}
  };

  const startMobileTrustCycle=()=>{
    window.clearInterval(trustTimer);
    const label=document.querySelector('[data-bm-trust-mobile-text]');
    const items=(config.trustItems||[]).filter(Boolean);
    if(!label||items.length<2||reduced.matches)return;
    let index=Math.max(0,items.indexOf(label.textContent.trim()));
    trustTimer=window.setInterval(()=>{
      index=(index+1)%items.length;
      label.classList.add('is-changing');
      window.setTimeout(()=>{
        label.textContent=items[index];
        label.classList.remove('is-changing');
      },180);
    },3300);
  };

  const removeAtmosphere=()=>{
    wheelSequence++;
    pendingWheelKey='';
    document.querySelector('[data-bm-header-atmosphere]')?.remove();
    currentWheelKey='';
    currentLayer='a';
  };

  const mountAtmosphere=()=>{
    const mast=document.querySelector('#header .head-mast-wrap');
    if(!mast||config.showAtmosphere===false){removeAtmosphere();return null}
    let layer=mast.querySelector('[data-bm-header-atmosphere]');
    if(!layer){
      layer=document.createElement('div');
      layer.className='bm-header-atmosphere';
      layer.setAttribute('data-bm-header-atmosphere','');
      layer.setAttribute('aria-hidden','true');
      layer.innerHTML='<span class="bm-header-tread bm-header-tread--a"></span><span class="bm-header-tread bm-header-tread--b"></span><span class="bm-header-wheel-stage" data-bm-header-wheel-stage><img data-bm-header-wheel-layer="a" alt=""><img data-bm-header-wheel-layer="b" alt=""></span>';
      mast.prepend(layer);
      requestAnimationFrame(()=>layer.classList.add('is-ready'));
    }
    const stage=layer.querySelector('[data-bm-header-wheel-stage]');
    if(stage){
      stage.hidden=config.showDynamicWheel===false;
      /* The image swap below owns wheel motion. Do not animate the stage as a second layer. */
      stage.style.transition='none';
    }
    return layer;
  };

  const swapHeaderWheel=async(brandName='')=>{
    const stage=document.querySelector('[data-bm-header-wheel-stage]');
    if(!stage||config.showDynamicWheel===false)return;
    const key=normaliseBrand(brandName);
    const url=(config.brandWheels||{})[key]||'';

    if(!url){
      wheelSequence++;
      pendingWheelKey='';
      currentWheelKey='';
      stage.classList.remove('has-wheel');
      stage.querySelectorAll('img').forEach(img=>{
        cancelAnimations(img);
        img.style.opacity='0';
        img.removeAttribute('src');
      });
      return;
    }

    /* Vehicle readiness/pageshow can fire almost together. One brand gets one swap only. */
    if(key===currentWheelKey||key===pendingWheelKey)return;
    pendingWheelKey=key;

    const sequence=++wheelSequence;
    const nextLayer=currentLayer==='a'?'b':'a';
    const current=stage.querySelector(`[data-bm-header-wheel-layer="${currentLayer}"]`);
    const next=stage.querySelector(`[data-bm-header-wheel-layer="${nextLayer}"]`);
    if(!current||!next){
      if(pendingWheelKey===key)pendingWheelKey='';
      return;
    }

    cancelAnimations(current);
    cancelAnimations(next);
    next.style.opacity='0';
    next.style.transform='translateX(22px) rotate(-9deg) scale(.96)';
    next.src=url;
    try{if(next.decode)await next.decode()}catch(_){}
    if(sequence!==wheelSequence){
      if(pendingWheelKey===key)pendingWheelKey='';
      return;
    }

    stage.classList.add('has-wheel');
    if(reduced.matches||typeof next.animate!=='function'){
      current.style.opacity='0';
      next.style.opacity='1';
      next.style.transform='translateX(0) rotate(-3deg) scale(1)';
    }else{
      const incoming=next.animate(
        [{opacity:0,transform:'translateX(22px) rotate(-9deg) scale(.96)'},{opacity:1,transform:'translateX(0) rotate(-3deg) scale(1)'}],
        {duration:440,easing:'cubic-bezier(.22,.75,.22,1)',fill:'both'}
      );
      const outgoing=current.getAttribute('src')?current.animate(
        [{opacity:1,transform:'translateX(0) rotate(-3deg) scale(1)'},{opacity:0,transform:'translateX(-8px) rotate(2deg) scale(.988)'}],
        {duration:230,easing:'cubic-bezier(.4,0,.2,1)',fill:'both'}
      ):null;

      await Promise.allSettled([incoming.finished,outgoing?.finished].filter(Boolean));
      if(sequence!==wheelSequence){
        if(pendingWheelKey===key)pendingWheelKey='';
        return;
      }

      cancelAnimations(incoming.effect?.target||next);
      if(outgoing)cancelAnimations(outgoing.effect?.target||current);
      current.style.opacity='0';
      next.style.opacity='1';
      next.style.transform='translateX(0) rotate(-3deg) scale(1)';
    }

    currentLayer=nextLayer;
    currentWheelKey=key;
    pendingWheelKey='';
  };

  const syncVehicleWheel=()=>{
    const active=window.BandenmeestersVehicle?.getActive?.()||null;
    swapHeaderWheel(active?.brand?.name||'');
  };

  class SearchTypewriter{
    constructor(input,phrases){
      this.input=input;
      this.phrases=phrases.filter(Boolean);
      this.phraseIndex=0;
      this.charIndex=0;
      this.mode='typing';
      this.timer=0;
      this.running=false;
      this.original=input.getAttribute('placeholder')||'Producten zoeken';
      this.onFocus=()=>this.stop(true);
      this.onInput=()=>{if(this.input.value)this.stop(true)};
      this.onBlur=()=>{if(!this.input.value){this.reset();window.setTimeout(()=>this.start(),180)}};
    }
    init(){
      if(this.input.dataset.bmHeaderTypewriter==='true'||!this.phrases.length)return;
      this.input.dataset.bmHeaderTypewriter='true';
      this.input.addEventListener('focus',this.onFocus);
      this.input.addEventListener('input',this.onInput);
      this.input.addEventListener('blur',this.onBlur);
      if(reduced.matches){this.input.setAttribute('placeholder',this.phrases[0]);return}
      if(document.activeElement!==this.input&&!this.input.value)this.start();
    }
    reset(){this.phraseIndex=0;this.charIndex=0;this.mode='typing'}
    start(){if(this.running||this.input.value||document.activeElement===this.input||!this.phrases.length)return;this.running=true;this.tick()}
    stop(useOriginal=false){this.running=false;window.clearTimeout(this.timer);if(useOriginal)this.input.setAttribute('placeholder',this.original)}
    schedule(delay){window.clearTimeout(this.timer);this.timer=window.setTimeout(()=>this.tick(),delay)}
    render(){this.input.setAttribute('placeholder',this.phrases[this.phraseIndex].slice(0,this.charIndex))}
    tick(){
      if(!this.running)return;
      const phrase=this.phrases[this.phraseIndex];
      if(this.mode==='typing'){
        this.charIndex=Math.min(phrase.length,this.charIndex+1);this.render();
        if(this.charIndex>=phrase.length){this.mode='hold';this.schedule(2200)}else this.schedule(48);
        return;
      }
      if(this.mode==='hold'){this.mode='deleting';this.schedule(50);return}
      this.charIndex=Math.max(0,this.charIndex-1);this.render();
      if(this.charIndex===0){this.phraseIndex=(this.phraseIndex+1)%this.phrases.length;this.mode='typing';this.schedule(260)}
      else this.schedule(28);
    }
  }

  const startTypewriter=()=>{
    if(config.searchTypewriter===false)return;
    const phrases=(config.searchPhrases||[]).filter(Boolean);
    document.querySelectorAll('#header .header-global-search-input').forEach(input=>new SearchTypewriter(input,phrases).init());
  };

  const measureHeader=()=>{
    const header=document.querySelector('#header');
    if(!header)return;
    const height=Math.ceil(header.getBoundingClientRect().height);
    if(height>0)document.documentElement.style.setProperty('--bm-header-sticky-offset',`${height}px`);
  };

  const observeHeader=()=>{
    resizeObserver?.disconnect?.();
    const header=document.querySelector('#header');
    if(header&&'ResizeObserver'in window){
      resizeObserver=new ResizeObserver(measureHeader);
      resizeObserver.observe(header);
    }
  };

  const refresh=()=>{
    config=readConfig();
    mountAtmosphere();
    startMobileTrustCycle();
    startTypewriter();
    observeHeader();
    measureHeader();
    syncVehicleWheel();
  };

  const boot=()=>{
    refresh();
    window.addEventListener('resize',measureHeader,{passive:true});
    window.addEventListener('pageshow',refresh);
    window.addEventListener('bm:vehicle:change',syncVehicleWheel);
    document.addEventListener('bm:vehicle:ready',syncVehicleWheel);
    document.addEventListener('shopify:section:load',()=>window.setTimeout(refresh,0));

    if(!window.BandenmeestersVehicle?.getActive){
      let tries=0;
      const retry=window.setInterval(()=>{
        tries++;
        if(window.BandenmeestersVehicle?.getActive||tries>20){
          window.clearInterval(retry);
          syncVehicleWheel();
        }
      },150);
    }
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
